export default (store) => {
    store.subscribeAction(async (action, state) => {
        if(action.type==='project/CLOSE'){
            await store.dispatch('indicatrix/CLOSE', action.payload)
        }
      })
}